import { render, staticRenderFns } from "./FundingCompetitionsView.vue?vue&type=template&id=3b5f4d48&"
import script from "./FundingCompetitionsView.vue?vue&type=script&lang=js&"
export * from "./FundingCompetitionsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports